import { render, staticRenderFns } from "./DashboardReportProduct.vue?vue&type=template&id=edf23972&scoped=true&"
import script from "./DashboardReportProduct.vue?vue&type=script&lang=js&"
export * from "./DashboardReportProduct.vue?vue&type=script&lang=js&"
import style0 from "./DashboardReportProduct.vue?vue&type=style&index=0&id=edf23972&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf23972",
  null
  
)

component.options.__file = "DashboardReportProduct.vue"
export default component.exports